// @flow

export const LANGUAGE_PORTUGUESE = 'pt';
export const LANGUAGE_SPANISH = 'es';
export const LANGUAGE_ENGLISH = 'en';
export const LANGUAGE_ARABIC = 'ar';

export const LANGUAGE_LABEL_ENGLISH = 'English | English';
export const LANGUAGE_LABEL_SPANISH = 'Spanish | Español';
export const LANGUAGE_LABEL_ARABIC = 'Arabic | عربي';
export const LANGUAGE_LABEL_PORTUGUESE = 'Portuguese | Português';

export type Language = { language: string, code: string };

export const LANGUAGES_BY_COUNTRY: { [key: string]: Language[] } = {
  br: [
    { language: LANGUAGE_LABEL_PORTUGUESE, code: LANGUAGE_PORTUGUESE },
  ],
  jm: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  ar: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  bo: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  cl: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  co: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  ec: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  mx: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  pe: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  uy: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  us: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  py: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  cr: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  gt: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  sv: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  pa: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  do: [
    { language: LANGUAGE_LABEL_SPANISH, code: LANGUAGE_SPANISH },
  ],
  za: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  ke: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  ng: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  tz: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  in: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  ug: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  zm: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  eg: [
    { language: LANGUAGE_LABEL_ARABIC, code: LANGUAGE_ARABIC },
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
  gh: [
    { language: LANGUAGE_LABEL_ENGLISH, code: LANGUAGE_ENGLISH },
  ],
};

export const LANGUAGE_BY_COUNTRY = {
  br: LANGUAGE_PORTUGUESE,
  ar: LANGUAGE_SPANISH,
  bo: LANGUAGE_SPANISH,
  cl: LANGUAGE_SPANISH,
  co: LANGUAGE_SPANISH,
  ec: LANGUAGE_SPANISH,
  mx: LANGUAGE_SPANISH,
  pe: LANGUAGE_SPANISH,
  uy: LANGUAGE_SPANISH,
  cr: LANGUAGE_SPANISH,
  py: LANGUAGE_SPANISH,
  pa: LANGUAGE_SPANISH,
  sv: LANGUAGE_SPANISH,
  gt: LANGUAGE_SPANISH,
  do: LANGUAGE_SPANISH,
  za: LANGUAGE_ENGLISH,
  ke: LANGUAGE_ENGLISH,
  ng: LANGUAGE_ENGLISH,
  in: LANGUAGE_ENGLISH,
  tz: LANGUAGE_ENGLISH,
  ug: LANGUAGE_ENGLISH,
  zm: LANGUAGE_ENGLISH,
  eg: LANGUAGE_ARABIC,
  gh: LANGUAGE_ENGLISH,
  jm: LANGUAGE_ENGLISH,
};
